import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogWrapperComponent } from '../wrappers/dialog-wrapper.component';
import { Wrapper } from '../wrapper.component';
import { eventMessagesReselector, EventMessagesReselectorResult } from '../../store/reselectors/events.reselector';
import { JoiComment } from '../../../../globals/store/tasks.data';
import { JoiEvent } from '../../../../globals/store/events.data';
import { ChatBoxComponent } from 'src/app/modules/manage/chat-box.component';
import { DecircularService } from 'src/app/services/decircular.service';

@Component({
    selector: 'messages-dialog',
    imports: [DialogWrapperComponent, ChatBoxComponent],
    template: `
<dialog-wrapper
  #dialogWrapper
  [smallTitle]="true"
  [giveMeTwenty]="true"
  [dialogTitle]="'Messages'"
  [dontResize]="true"
  [titleHeight]="40"
  [hideBottom]="true"
  [showClose]="true"
  (close)="close()"
>
  @if(!!this.messages){
    <chat-box [isMessages]="true" [comments]="messages" [unreadIds]="newMessageIds" [readOnly]="!event || event.is_readonly || !event.can_access" (addComment)="addMessage($event)"></chat-box>
  }
</dialog-wrapper>
`,
    styleUrls: ['./messages.dialog.sass'],
    standalone: true,
})
export class MessagesDialogComponent extends Wrapper<MessagesDialogComponent> implements OnInit {
  @ViewChild(DialogWrapperComponent, { static: true }) dialogWrapper : DialogWrapperComponent;
  newMessageIds: string[]
  messages: JoiComment[]
  event: JoiEvent
  private decircularService = inject(DecircularService)
  
  constructor(public dialogRef: MatDialogRef<MessagesDialogComponent>) { 

    super()
    this.subProp(this.store.select('events', 'event'), 'event')
  }

  ngOnInit() {
    this.selectCallback(eventMessagesReselector, null, (data: EventMessagesReselectorResult) => {
      if (!data) return
      console.log(data)
      this.newMessageIds = data.newMessageIds
      this.messages = data.messages
      this.dialogWrapper.jumpToBottom()
    })
    window['dialogWrapper'] = this.dialogWrapper
  }

  updateUserMessageCutoff(newMessage?: JoiComment) {

    const n = this.messages.length
    const message = newMessage || (n ? this.messages[n-1] : null)

    console.log({ message })
    if (!message) return

    const uid = this.userService.uid
    const cutoff = this.event.messageCutoffs[uid] || 0

    const newestTime = message['dateModified']
    // console.log({ cutoff, newestTime })

    if (cutoff >= newestTime) return
    const messageCutoffs = { ...this.event.messageCutoffs }
    messageCutoffs[uid] = newestTime

    if (cutoff < newestTime) this.decircularService.updateMessageCutoff({ eventId: this.event.eventId, cutoff: newestTime })
  }

  async addMessage(message: JoiComment) {
    message.dateModified = new Date().getTime()
    await this.decircularService.sendMessage({ eventId: this.event.eventId, message })
    this.dialogWrapper.jumpToBottom()
  }

  close() {
    this.updateUserMessageCutoff()
    this.dialogRef.close()
  }
}
